export namespace CacheExpiryConstants {
  export const DEFAULT_CACHE_EXPIRY = 20;
  export const USER_CACHE_EXPIRY = 24 * 60;
  export const RESERVATION_CACHE_EXPIRY = 0;
  export const RIDE_REQUEST_CACHE_EXPIRY = 0;
  export const TRANSIT_PROGRAM_CACHE_EXPIRY = 24 * 60;
  export const DOMAIN_CACHE_EXPIRY = 24 * 60;
  export const RULE_VALUE_CACHE_EXPIRY = 24 * 60;
}
